import { semantical } from 'src/theme/tokens/semantical';

export const theme = {
  ...semantical,
};

export type AppTheme = typeof theme;